@if (zipCodeAvailable) {
  <span class="sml-preview">
    <span class="sml-preview__method">{{ methodName }}</span>
    @if (priceLabel) {
      <span class="sml-preview__price">{{ priceLabel }}</span>
    }
    @if (showChangeButton) {
      <span class="sml-preview__separator">|</span>
      <button type="button" class="sml-preview__change" [innerHTML]="buttonLabelHtml | safe"></button>
    }
  </span>
}
